import { createFileRoute } from "@tanstack/react-router"

import ReserveGuardCard from "../../../../../-components/ReserveGuardCard"

export const Route = createFileRoute(
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/in-progress"
)({
  staticData: {
    pageName: "Reservation In Progress",
  },
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { qrLookupID } = Route.useParams()
  const { sessionState } = Route.useRouteContext()

  return (
    <ReserveGuardCard
      iconName="alert"
      heading="reservationInProgress.heading"
      body="reservationInProgress.body"
      actionLabel="reservationInProgress.returnToRates"
      qrLookupID={qrLookupID}
      onAction={() =>
        navigate({
          to: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates",
          search: { endDate: sessionState.selectedEndDateOnly || undefined },
        })
      }
    />
  )
}
